import Waypoint from 'exports?Waypoint!waypoints/lib/noframework.waypoints.js'
import Parallax from 'parallax-js'

/**
* Project functionality.
* @author Dayne Coulson-Hoffacker
*/
export default class Project {
  /**
  * Constructs a new HomeSection instance.
  * @param {Object} options - Options.
  * @param {HTMLElement} options.element - Container.
  */

  constructor (options) {
    this.element = options.element
    this.projectInformation = this.element.querySelector('[data-component="project-information"]')
    this.projectHero = this.element.previousElementSibling
    this.projectHeroImage = this.projectHero.querySelector('[data-component="project-hero-image"]')
    const touchDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)

    if (!touchDevice) {
      var scene = this.projectHeroImage
      var parallaxInstance = new Parallax(scene, {
        relativeInput: true,
        hoverOnly: true
      })
    }


    const self = this
    var waypoint = new Waypoint({
      element: this.projectInformation,
      handler: function(direction) {
        if (direction == 'down') {
          document.body.classList.add('dark-logo-toggles')
        } else {
          document.body.classList.remove('dark-logo-toggles')
        }
      }
    })
  }
}



// WEBPACK FOOTER //
// ./components/project/index.js